module.exports = __webpack_public_path__ + "static/media/crow_roti_taking_from_river01.34e5f496.png";